module.exports = __webpack_public_path__ + "static/media/c118.a752c7f3.jpg";